import { Form, Input, ModalProps, FormProps, Modal, Select, InputNumber, useSelect, message } from '@pankod/refine-antd'
import { useGetIdentity } from '@pankod/refine-core'
import { useUserContext } from 'context/user'
import { createUserHistory, updateProjectReportThemeIds } from 'gql/mutations'
import { findProjectFieldName, getReportThemeDataByTopicId } from 'gql/query'

import { IProject, ISubject, ITopic } from 'interfaces'

type CreateReportThemeProps = {
  modalProps: ModalProps
  formProps: FormProps
  // refetchProjectDetails: () => void
}

export const CreateReportTheme: React.FC<CreateReportThemeProps> = ({ modalProps, formProps }) => {
  const { data: user } = useGetIdentity()

  // const { selectProps: topicSelectProps } = useSelect<ITopic>({
  //   resource: 'topics',
  //   fetchSize: 1000,
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   sort: [{ field: 'created_at', order: 'desc' }],
  //   onSearch: value => [
  //     {
  //       field: 'name',
  //       operator: 'contains',
  //       value: `${value.toLowerCase()}%`,
  //     },
  //   ],
  // })

  const { selectProps: themeSelectProps } = useSelect<ITopic>({
    resource: 'themes',
    fetchSize: 100000,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'created_at', order: 'desc' }],
    filters: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })

  const { userRole } = useUserContext()

  const onFinish = async (values: any) => {
    try {
      formProps?.form?.resetFields()
      if (values && values?.name?.trim() && values?.theme_ids && values?.theme_ids?.length > 0) {
        console.log(values, 'values is this')
        const isNameRepeated: any = await findProjectFieldName(values?.name, 'name', 'report_themes')
        console.log(isNameRepeated, 'is name repeated')
        if (isNameRepeated && isNameRepeated?.report_themes?.length === 0) {
          //extracting project_ids from the object
          const { project_ids, ...newValues } = values
          return (
            formProps.onFinish &&
            formProps.onFinish({
              ...newValues,
              created_by: user?.id,
            })
          )
        } else {
          message.error("Can't add report theme with repeated name...")
        }
      } else {
        message.error(`Expected values are missing...`)
      }
    } catch (err) {
      console.log(err)
      message.error('Unable to add the values, please try again later')
    }
  }

  return (
    <Modal {...modalProps} title="Create Report Theme">
      <Form
        {...formProps}
        size="large"
        layout="vertical"
        onFinish={async values => {
          let response = await onFinish(values).then(async (response: any) => {
            if (response && response?.data?.id) {
              // if (values?.project_ids?.length > 0) {
              //   //adding created RT to project table
              //   for (const project of values.project_ids) {
              //     const updateProjects = await updateProjectReportThemeIds(project, response?.data?.id)
              //     if (updateProjects) {
              //       console.log(response?.data?.id, 'added to this project:', project)
              //     }
              //   }
              //   await refetchProjectDetails()
              // }
              createUserHistory('report_themes', 'create', response?.data?.id, user?.id, userRole)
            }
          })

          return response
        }}
      >
        <Form.Item
          label="Report Theme Name"
          name="name"
          rules={[
            {
              required: true,
              message: 'Name is required',
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item label="Themes" name="theme_ids" rules={[{ required: true, message: 'please select atleast one theme id' }]}>
          <Select {...themeSelectProps} mode="multiple" />
        </Form.Item>

        {/* <Form.Item label="Projects" name="project_ids" labelCol={{ span: 24 }}>
          <Select {...projectSelectProps} mode="multiple" />
        </Form.Item> */}

        <Form.Item name="created_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
